<div class="col-xs-12 ticket-title">
    <h3  class="ticketdetails-title">{{'customerService.ticketdetails-title'|cxTranslate}}</h3>
    <div class="createTicket create-ticket-comp" id="addnewticketdialoglink" (click)="openCreateTicketModal()">
        <span class="text">{{'customerService.createTicket'|cxTranslate}}</span>
        <span class="round-add"></span>
    </div>
</div>
<h6 class="ticketh6">{{'customerService.ticketDetailsTitle'|cxTranslate}}</h6>
<table  aria-describedby="ticketdetails-table" id=" ticketdetails-table" *ngIf="recentTickets?.length>0"
    class="ticketdetails-page table table-striped">
    <thead >
        <tr >
            <th scope="col"> Nº Ticket</th>
            <th scope="col"> Tipo</th>
            <th scope="col"> Status </th>
        </tr>
    </thead>

    <tbody >
        <tr  *ngFor="let tickets of recentTickets"> 
            <td ><a (click)="viewTicket(tickets?.id)" data-di-id="di-id-e67a9540-a33d106c"> {{tickets?.id}}</a>
            </td>
            
            <td><span >{{tickets?.ticketCategory?.name}}
                </span>
            </td>
            <td ><span >{{tickets?.status?.name}}</span>
            </td>
        </tr>
    </tbody>
</table>
<div *ngIf="recentTickets?.length === 0" class="text-center no-tickets"> {{'customerService.no-tickets'|cxTranslate}} </div>
<button  type="button" class="btn btn-primary float-right btnview-alltickets" tabindex="0" (click)="openAllTickets()">{{'customerService.viewTicketDetails'|cxTranslate}} </button>

